import styled from 'styled-components';

import { Props as ProgressBarProps } from './index';

interface StyledProps {
  percentage: number;
}

export const Container = styled.div`
  position: relative;
  height: 4px;
  width: 100%;
`;

export const Filler = styled.div.attrs<ProgressBarProps, StyledProps>((): any => {})`
  background: ${({ theme }) => theme.links.color};
  height: 100%;
  width: ${(props) => props.percentage}%;
  transition: width 1s ease-in;
`;
